export class NodeAspect {
    constructor(isExpanded: boolean = false) {
        this.isExpanded = isExpanded;
    }
    isExpanded: boolean = false;
    isSelected: boolean = false;
    isEditing: boolean = false;
    isHovering: boolean = false;
}